module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-1063.f2bf83da.jpg";